import { createContext, useContext, useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Transition } from '@headlessui/react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((type, message) => {
    const id = uuidv4();
    setToasts((prev) => [...prev, { id, type, message }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, 4000);
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}

      {/* Toast container */}
      <div className="fixed bottom-4 right-4 left-4 md:left-auto flex flex-col items-end space-y-3 z-50 max-w-sm md:max-w-md">
        {toasts.map((toast) => (
          <Transition
            key={toast.id}
            show={true}
            enter="transform transition duration-300 ease-out"
            enterFrom="opacity-0 translate-y-2"
            enterTo="opacity-100 translate-y-0"
            leave="transform transition duration-200 ease-in"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-2"
          >
            <div
              className={`flex items-start gap-3 p-4 rounded-md border-l-4 text-sm shadow-xl w-full
                ${toast.type === 'success' && 'bg-white border-green-400 text-green-500'}
                ${toast.type === 'info' && 'bg-white border-blue-400 text-blue-500'}
                ${toast.type === 'warning' && 'bg-white border-yellow-400 text-yellow-500'}
                ${toast.type === 'error' && 'bg-white border-red-400 text-red-500'}
              `}
            >
              <span className="flex-1">{toast.message}</span>
            </div>
          </Transition>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
